import {
  Activity,
  ClipboardList,
  Filter,
  Globe,
  Grid2x2,
  HeartPulse,
  Images,
  Layers,
  LayoutDashboard,
  List,
  MapPin,
  MessageCircle,
  MessageSquare,
  Package,
  PenLine,
  Plug,
  Route,
  Search,
  Settings,
  ShoppingBag,
  Star,
  Tags,
  TriangleAlert,
  Truck,
  UserCheck,
  Users,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const PANTRY_NAV_ICONS: Record<string, LucideIcon> = {
  LayoutDashboard,
  Grid2x2,
  List,
  Layers,
  Tags,
  MessageSquare,
  MessageCircle,
  Users,
  ClipboardList,
  Star,
  Truck,
  PenLine,
  Images,
  Settings,
  MapPin,
  Plug,
  ShoppingBag,
  // Storefront Analytics section
  Activity,
  Search,
  Package,
  Filter,
  Globe,
  UserCheck,
  Route,
  TriangleAlert,
  HeartPulse,
}

export const resolveIcon = (name?: string | null): LucideIcon | null => {
  if (!name) return null
  return PANTRY_NAV_ICONS[name] ?? null
}
